import styled from 'styled-components'

import { COLORS } from 'consts/colors'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'

export const DiscountButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  height: 34px;
  background: linear-gradient(90deg, #f0367b 0%, #db2ff1 100%);

  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    opacity: 0.9;
  }

  & > svg {
    flex-shrink: 0;
  }

  & > .discount-label {
    font-size: 16px;
    font-weight: 800;
    color: ${COLORS.white};
    white-space: nowrap;
  }

  & > .discount-countdown {
    font-size: 16px;
    font-weight: 400;
    color: ${COLORS.white};
    white-space: nowrap;
    font-variant-numeric: tabular-nums;

    @media only screen and (max-width: 1380px) {
      display: none;
    }
  }

  /* The label alone (14px, no countdown) keeps the button compact enough
     for narrow headers, so the icon is dropped instead of the text */
  @media only screen and (max-width: 1100px) {
    & > svg {
      display: none;
    }

    & > .discount-label {
      font-size: 14px;
    }
  }

  @media only screen and (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
    gap: 6px;
    padding: 8px;
  }
`
